import React, { useState, useEffect, useRef } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import {
  DownloadClientsDataInExcel,
  FilterJsonContainingMatchingValues,
  FilterJsonExactlyMatching,
  formateDate,
  getEndOfMonth,
  getFirstDateOfCurrentMonth,
  getLastDateOfCurrentPlus1Month,
  GetSelectedIDsFromList,
  getStartOfMonth,
} from "../Shared/Utility";
import { useGlobalState } from "../Context/GlobalStateContext";
import QuoteInfo from "../App/QuoteInfo";
import CompleteJob from "../App/CompleteJob";
import Conversation from "../App/Conversation";
import { showErrorMessage, showSuccessMessage } from "../Shared/Toast";

function DriversDashboard() {
  const globalState = useGlobalState();
  const [SelectedDate, setSelectedDate] = useState("01/01/1900");
  const [isAnimation, setIsAnimation] = useState(false);
  const [IsDriver, setIsDriver] = useState(false);
  const [clearFilters, setClearFilters] = useState(false);
  const [dashboardObject, setDashboardObject] = useState<any>({
    EndDate: getLastDateOfCurrentPlus1Month(),
    JobID: "",
    MNVMoverID: 0,
    StartDate: getFirstDateOfCurrentMonth(),
    EarningsView: true,
    Total: 0,
  });

  const [AutoSaveMessage, setAutoSaveMessage] = useState(false);
  const [gridData, setGridData] = useState<any>([]);
  const [gridDataDB, setGridDataDB] = useState<any>([]);

  const [driverFeedback, setDriverFeedback] = useState({
    MNVQuoteID: 0,
    RelMNVQuoteAndMNVMoverID: 0,
    Notes: "",
    Amount: 0,
  });

  const [showMaterialsModal, setShowMaterialsModal] = useState(false);
  const [materialsNotes, setMaterialsNotes] = useState("");
  const [numberOfBoxes, setNumberOfBoxes] = useState(0);
  const [selectedMNVQuoteID, setSelectedMNVQuoteID] = useState(0);

  useEffect(() => {
    ClearFilters(false);
    setIsDriver(globalState.IsDriverLoggedIn);
    getDriverJobs();
  }, [clearFilters]);

  function ClearFilters(clear: boolean) {
    var l_oToday = new Date();
    setDashboardObject((prevState: any) => ({
      ...prevState,
      StartDate: getFirstDateOfCurrentMonth(),
      EndDate: getLastDateOfCurrentPlus1Month(),
      JobID: "",
    }));
    if (clear == true) setClearFilters(!clearFilters);
  }

  function getDriverJobs() {
    setIsAnimation(true);
    let data = {} as any;
    data.Date = new Date(SelectedDate);
    data.StartDate = new Date(dashboardObject.StartDate);
    data.EndDate = new Date(dashboardObject.EndDate);
    data.JobID = dashboardObject.JobID;
    axiosAuth
      .post(AppContext.APIURL + "api/MNVQuoteAdmin/MNVQuoteGetDriverJobs", data)
      .then((response) => {
        if (response.status === 200) {
          let l_response = response.data;
          if (
            l_response[1].length > 0 &&
            l_response[1][0]["MNVMoverTypeID"] != 2
          ) {
            setIsDriver(true);
          }

          if (l_response[0].length > 0) {
            setDashboardObject((prevState: any) => ({
              ...prevState,
              MNVMoverID: l_response[0][0]["MNVMoverID"],
            }));
          }
          setGridData(l_response[0]);
          setGridDataDB(l_response[2]);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function GetDriverAndHelpersText(
    p_intMNVQuoteID: any,
    p_boolShowAlert = false,
    p_boolShowOnlyFirstName = false,
    thisEventsListDB: any,
  ) {
    var l_arrFilteredData = FilterJsonExactlyMatching(
      thisEventsListDB,
      "MNVQuoteID",
      p_intMNVQuoteID,
    );
    var l_strText = "";
    for (var i = 0; i < l_arrFilteredData.length; i++) {
      var l_strMoverName = l_arrFilteredData[i]["MNVMoverName"];
      if (p_boolShowOnlyFirstName) {
        var l_arrMoverName = l_strMoverName.split(" ");
        if (l_arrMoverName.length > 0) l_strMoverName = l_arrMoverName[0];
      }
      if (i == 0) l_strText = "D: " + l_strMoverName;
      else if (i == 1) l_strText += "; H1: " + l_strMoverName;
      else if (i >= 2) l_strText += "; H" + i + ": " + l_strMoverName;
    }

    if (p_boolShowAlert) {
      globalState.setNotificationObject({
        ShowPopup: true,
        Heading: "",
        Message: l_strText,
      });
    }

    return l_strText;
  }

  function GetFromFloorText(p_strText: any) {
    globalState.setNotificationObject({
      ShowPopup: true,
      Heading: "",
      Message: p_strText,
    });
  }

  const [showQuoteModal, setShowQuoteModal] = useState(false);
  const [showCompleteModal, setShowCompleteModal] = useState(false);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [quoteID, setQuoteID] = useState(0);
  function OpenInfoPopUp_Detail(content: any, JobID: any) {
    setQuoteID(JobID);
    setShowQuoteModal(true);
  }

  function OpenMessagePopUp_Detail(content: any, JobID: any) {
    setQuoteID(JobID);
    setShowMessageModal(true);
  }

  function ChangeJobStatus(
    p_intRelMNVQuoteAndMNVMoverID: any,
    p_intStatus: any,
    p_intMNVQuoteID: any,
    p_oElement: any = "",
  ) {
    let data = {} as any;
    data.RelMNVQuoteAndMNVMoverID = p_intRelMNVQuoteAndMNVMoverID;
    data.Status = p_intStatus;
    setAutoSaveMessage(false);
    if (IsDriver && p_intStatus == 5) {
      setDriverFeedback((prevState: any) => ({
        ...prevState,
        RelMNVQuoteAndMNVMoverID: p_intRelMNVQuoteAndMNVMoverID,
        MNVQuoteID: p_intMNVQuoteID,
      }));

      setShowCompleteModal(true);
    } else if (p_intStatus != 5) {
      axiosAuth
        .post(
          AppContext.APIURL + "api/MNVQuoteAdmin/MNVQuoteUpdateDriverJobStatus",
          data,
        )
        .then(() => {
          getDriverJobs();
        })
        .catch((error) => console.error(error));
    }
  }

  const SendWhatsAppToMover = (p_intMNVQuoteID: any) => {
    if (globalState.UserMobile && globalState.UserMobile !== "") {
      if (p_intMNVQuoteID > 0) {
        AjaxSendJobDetailsToMovers(
          p_intMNVQuoteID,
          globalState.UserMobile,
          true,
        );
      } else {
        const l_arrAcceptedJobs = FilterJsonContainingMatchingValues(
          gridData,
          "JobStatus",
          4,
        );

        for (let i = 0; i < l_arrAcceptedJobs.length; i++) {
          let l_boolIsLast = false;
          if (i === l_arrAcceptedJobs.length - 1) l_boolIsLast = true;

          AjaxSendJobDetailsToMovers(
            l_arrAcceptedJobs[i].MNVQuoteID,
            globalState.UserMobile,
            l_boolIsLast,
          );
        }
      }
    } else {
      showErrorMessage("Invalid Mobile No.");
    }
  };

  const AjaxSendJobDetailsToMovers = (
    QuoteID: any,
    UserMobile: any,
    p_boolLastJob: any,
  ) => {
    let data = {} as any;
    data.MNVQuoteID = QuoteID;
    data.MoverMobile = UserMobile;
    data.MNVMoverID = dashboardObject.MNVMoverID;

    setIsAnimation(true);

    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVQuoteAdmin/AjaxSendJobDetailsToMovers",
        data,
      )
      .then((response) => {
        setIsAnimation(false);

        const StatusData = response.data[0];

        if (StatusData.Status === 1) {
          if (p_boolLastJob)
            showSuccessMessage("Job Details has been sent to WhatsApp.");
        } else if (p_boolLastJob) {
          showErrorMessage(StatusData.Message);
        }
      })
      .catch((error) => {
        setIsAnimation(false);
        console.error(error);
      });
  };

  const SendEmailsToMover = (p_intMNVQuoteID: any) => {
    if (globalState.UserEmail && globalState.UserEmail !== "") {
      if (p_intMNVQuoteID > 0) {
        SendQuotationEmailToMover(p_intMNVQuoteID, globalState.UserEmail, true);
      } else {
        const l_arrAcceptedJobs = FilterJsonContainingMatchingValues(
          gridData,
          "JobStatus",
          4,
        );

        for (let i = 0; i < l_arrAcceptedJobs.length; i++) {
          let l_boolIsLast = false;
          if (i === l_arrAcceptedJobs.length - 1) l_boolIsLast = true;

          SendQuotationEmailToMover(
            l_arrAcceptedJobs[i].MNVQuoteID,
            globalState.UserEmail,
            l_boolIsLast,
          );
        }
      }
    } else {
      showErrorMessage("Invalid Email.");
    }
  };

  const SendQuotationEmailToMover = (
    MNVQuoteID: any,
    MoverEmailAddress: any,
    p_boolLastEmail: any,
  ) => {
    let data = {} as any;
    data.MNVQuoteID = MNVQuoteID;
    data.EmailAddress = MoverEmailAddress;

    setIsAnimation(true);

    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVQuoteAdmin/SendQuotationEmailToMover",
        data,
      )
      .then((response) => {
        setIsAnimation(false);

        const StatusData = response.data[0];

        if (StatusData.Status === 1) {
          if (p_boolLastEmail)
            if (p_boolLastEmail) showSuccessMessage(StatusData.Message);
        } else {
          if (p_boolLastEmail) showErrorMessage(StatusData.Message);
        }
      })
      .catch((error) => {
        setIsAnimation(false);
        console.error(error);
      });
  };

  function ClosePopupAndAutoSendSms() {
    setAutoSaveMessage(true);
    setShowCompleteModal(false);
    getDriverJobs();
  }

  function showMaterailsRequired(MNVQuoteID: any) {
    GetMNVQuoteOtherDataByMNVQuoteID(MNVQuoteID);
    setSelectedMNVQuoteID(MNVQuoteID);
  }

  const GetMNVQuoteOtherDataByMNVQuoteID = (MNVQuoteID: any) => {
    let data = {} as any;
    data.MNVQuoteID = MNVQuoteID;
    setIsAnimation(true);
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVQuoteAdmin/GetMNVQuoteOtherDataByMNVQuoteID",
        data,
      )
      .then((response) => {
        setIsAnimation(false);
        setShowMaterialsModal(true);
        const QuoteData = response.data.Data;

        if (
          QuoteData &&
          QuoteData[0] &&
          QuoteData[0][0] &&
          QuoteData[0][0]?.AdminNotes
        ) {
          setMaterialsNotes(QuoteData[0][0]?.MoverNotesForMaterials);
          setNumberOfBoxes(QuoteData[0][0]?.NumberOfBoxes);
        } else {
          setMaterialsNotes("");
          setNumberOfBoxes(0);
        }
      })
      .catch((error) => {
        setIsAnimation(false);
        console.error(error);
      });
  };

  function saveMaterialsNotes() {
    AddMoversNotesForMaterials();
  }

  async function AddMoversNotesForMaterials() {
    setIsAnimation(true);
    try {
      const data: any = {
        MNVQuoteID: selectedMNVQuoteID,
        NumberOfBoxes: numberOfBoxes,
        MoverNotesForMaterials: materialsNotes,
      };
      const res = await axiosAuth.post(
        AppContext.APIURL + "api/MNVQuoteAdmin/AddMoversNotesForMaterials",
        data,
      );
      setIsAnimation(false);
      setShowMaterialsModal(false);
    } catch (err) {
      console.error("updateBoxEsReturnData error:", err);
    } finally {
      setIsAnimation(false);
      setShowMaterialsModal(false);
    }
  }

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}

      <div className="flex-d justify-btw mb-10">
        <div className="flex-da gap-10 wrap-flex">
          <div className="field-input">
            <input
              title="Job ID"
              placeholder="Job ID"
              value={dashboardObject.JobID}
              onChange={(e) =>
                setDashboardObject((prevState: any) => ({
                  ...prevState,
                  JobID: e.target.value,
                }))
              }
              className="input-field"
            />
          </div>
          <div className="field-input">
            <input
              type="date"
              title="Service Start Date"
              placeholder="Lag"
              value={dashboardObject.StartDate}
              onChange={(e) =>
                setDashboardObject((prevState: any) => ({
                  ...prevState,
                  StartDate: e.target.value,
                }))
              }
              className="input-field"
            />
          </div>
          <div className="field-input">
            <input
              type="date"
              title="Service End Date"
              placeholder="Lag"
              value={dashboardObject.EndDate}
              onChange={(e) =>
                setDashboardObject((prevState: any) => ({
                  ...prevState,
                  EndDate: e.target.value,
                }))
              }
              className="input-field"
            />
          </div>
          <div className="flex-daj btn-start flex-gap10">
            <a
              onClick={() => ClearFilters(true)}
              className="btn-primary flex-daj"
            >
              Clear Filters
            </a>
            <a onClick={() => getDriverJobs()} className="btn-primary flex-daj">
              Filter
            </a>
          </div>
        </div>
      </div>

      <div className=" grid-d fr-111 flex-gap20 sm-grid-ddb">
        {/* ACCEPTED */}
        <div className="flex-gap10 show-1150">
          <div className="flex-da justify-btw def-box-head">
            <span className="bold-font text-uppercase font16 c-theme">
              Accepted
            </span>
            <div className="btn-start flex-daj flex-gap10">
              <a
                className="flex-daj btn-primary font-10"
                onClick={() => SendWhatsAppToMover(0)}
              >
                Send All WhatsApp
              </a>
              <a
                className="flex-daj btn-primary font-10"
                onClick={() => SendEmailsToMover(0)}
              >
                Send All Emails
              </a>
            </div>
          </div>
          <div className="flow-boxes flow-boxes2">
            {gridData &&
              gridData.map(
                (job: any, index: any) =>
                  job.JobStatus == 4 && (
                    <div
                      className="shadow-box-sm grid-d flex-gap10"
                      key={index}
                    >
                      <div className="flex-da justify-btw">
                        {/* <span className="job-01">#{job.JobID}</span> */}
                        <div className="grid-d">
                          <span className="job-01">#{job.JobID}</span>
                          {job.ServiceName && job.ServiceName != "" && (
                            <span
                              className="font-12 c-theme"
                              style={{ lineHeight: "12px" }}
                            >
                              {job.ServiceName}
                            </span>
                          )}
                        </div>
                        <a
                          title={GetDriverAndHelpersText(
                            job.MNVQuoteID,
                            false,
                            false,
                            gridDataDB,
                          )}
                          onClick={() =>
                            GetDriverAndHelpersText(
                              job.MNVQuoteID,
                              true,
                              false,
                              gridDataDB,
                            )
                          }
                          className="dh-01"
                        >
                          {job.MNVMoverTypeID === 1 && "D"}
                          {job.MNVMoverTypeID === 2 && "D+1"}
                          {job.MNVMoverTypeID >= 3 &&
                            `D+${job.MNVMoverTypeID - 1}`}
                        </a>

                        {job.VanTypeFirstLetter === "T" && (
                          <span className="van-01 green-box01">
                            {job.VanTypeFirstLetter}
                          </span>
                        )}
                        {job.VanTypeFirstLetter === "L" && (
                          <span className="van-01 blue-box01">
                            {job.VanTypeFirstLetter}
                          </span>
                        )}

                        {/* {IsDriver && ( */}
                        <a
                          title="Mark as Completed"
                          onClick={() =>
                            ChangeJobStatus(
                              job.RelMNVQuoteAndMNVMoverID,
                              5,
                              job.MNVQuoteID,
                              "CompleteJob",
                            )
                          }
                          className="booked-01"
                          style={{ background: "#22b14c" }}
                        >
                          A
                        </a>
                        {/* )} */}

                        {/* {!IsDriver && (
                          <a
                            title="Accepted"
                            className="booked-01"
                            style={{ background: "#22b14c" }}
                          >
                            A
                          </a>
                        )} */}

                        <a
                          onClick={() => SendWhatsAppToMover(job.MNVQuoteID)}
                          className="flex-d"
                          title={"Send WhatsApp"}
                        >
                          <img
                            src="/images/whatsapp.svg"
                            width="24"
                            height="20"
                            alt="env"
                          />
                        </a>

                        <a
                          onClick={() => SendEmailsToMover(job.MNVQuoteID)}
                          className="flex-d"
                          title={"Send Email"}
                        >
                          <img
                            src="/images/envelopen.svg"
                            width="24"
                            height="20"
                            alt="env"
                          />
                        </a>

                        {job.LiabilityText !== "" && (
                          <a
                            onClick={() => GetFromFloorText(job.LiabilityText)}
                            className="flex-d"
                            title={job.LiabilityText}
                          >
                            <img
                              src="/images/warning.svg"
                              width="24"
                              height="20"
                              alt="warning"
                            />
                          </a>
                        )}

                        {job.FromFloor !== "" && (
                          <a
                            onClick={() => GetFromFloorText(job.FromFloor)}
                            className="flex-d tooltip-wrapper"
                          >
                            {" "}
                            <img
                              src="/images/flag.svg"
                              width="18"
                              height="20"
                              alt="Flag"
                            />
                            <div
                              className="tooltip2"
                              dangerouslySetInnerHTML={{
                                __html: job.FromFloor,
                              }}
                            ></div>
                          </a>
                        )}

                        <a
                          className="flex-d"
                          title="Messages"
                          onClick={() =>
                            OpenMessagePopUp_Detail("", job.MNVQuoteID)
                          }
                        >
                          <img
                            src="/images/comment-t.svg"
                            width="20"
                            height="20"
                            alt="Info"
                          />
                        </a>

                        {job.ClientInstructions === "" ? (
                          <a
                            className="flex-d"
                            title="View Details"
                            onClick={() =>
                              OpenInfoPopUp_Detail("Summary", job.MNVQuoteID)
                            }
                          >
                            <img
                              src="/images/info-norm.svg"
                              width="20"
                              height="20"
                              alt="Info"
                            />
                          </a>
                        ) : (
                          <a
                            title={job.ClientInstructions}
                            onClick={() =>
                              OpenInfoPopUp_Detail("Summary", job.MNVQuoteID)
                            }
                          >
                            <img
                              src="/images/info-red.svg"
                              width="20"
                              height="20"
                              alt="Info"
                            />
                          </a>
                        )}
                      </div>

                      <div className="flex-da justify-btw c-theme font-12">
                        <span>{formateDate(job.StartTime)}</span>
                        <span>arr {job.RequestedTimeReplaced}</span>
                        <span>for {job.RequiredVanTime}hrs</span>
                      </div>

                      <div className="flex-da justify-btw">
                        <div className="font-12">
                          <span>Postcodes</span>
                        </div>
                        {job.MNVMaterialsPriceTemplateID > 0 && (
                          <a
                            title="Materails Required"
                            className="flex-d"
                            onClick={() => {
                              showMaterailsRequired(job.MNVQuoteID);
                            }}
                          >
                            <img
                              src="/images/material-req.svg"
                              width="20"
                              height="20"
                              alt="Flag"
                            />
                          </a>
                        )}
                        {job.CongestionFee > 0 && (
                          <a
                            title="Congestion Charges Applied!"
                            className="c-charge"
                          >
                            C
                          </a>
                        )}

                        {job.IsShowLockEmoji === 1 && (
                          <a title="Our Storage" className="flex-d">
                            <img
                              src="/images/lock-g.svg"
                              width="20"
                              height="20"
                              alt="Flag"
                            />
                          </a>
                        )}

                        <span className="c-theme font-13">
                          {job.FromPostalCode} to {job.ToPostalCode}
                        </span>
                      </div>
                    </div>
                  ),
              )}
          </div>
        </div>

        {/* ASSIGNED */}
        <div className="flex-gap10">
          <div className="flex-da justify-btw def-box-head">
            <span className="bold-font text-uppercase font16 c-theme">
              Assigned
            </span>
          </div>
          <div className="flow-boxes flow-boxes2">
            {gridData &&
              gridData.map(
                (job: any, index: any) =>
                  (job.JobStatus == 2 || job.JobStatus == 3) && (
                    <div
                      className="shadow-box-sm grid-d flex-gap10"
                      key={index}
                    >
                      <div className="flex-da justify-btw">
                        {/* <span className="job-01">#{job.JobID}</span> */}
                        <div className="grid-d">
                          <span className="job-01">#{job.JobID}</span>
                          {job.ServiceName && job.ServiceName != "" && (
                            <span
                              className="font-12 c-theme"
                              style={{ lineHeight: "12px" }}
                            >
                              {job.ServiceName}
                            </span>
                          )}
                        </div>
                        <a
                          title={GetDriverAndHelpersText(
                            job.MNVQuoteID,
                            false,
                            false,
                            gridDataDB,
                          )}
                          onClick={() =>
                            GetDriverAndHelpersText(
                              job.MNVQuoteID,
                              true,
                              false,
                              gridDataDB,
                            )
                          }
                          className="dh-01"
                        >
                          {job.MNVMoverTypeID === 1 && "D"}
                          {job.MNVMoverTypeID === 2 && "D+1"}
                          {job.MNVMoverTypeID >= 3 &&
                            `D+${job.MNVMoverTypeID - 1}`}
                        </a>

                        {job.VanTypeFirstLetter === "T" && (
                          <span className="van-01 green-box01">
                            {job.VanTypeFirstLetter}
                          </span>
                        )}
                        {job.VanTypeFirstLetter === "L" && (
                          <span className="van-01 blue-box01">
                            {job.VanTypeFirstLetter}
                          </span>
                        )}

                        {job.JobStatus === 2 && (
                          <a
                            title="Provisional"
                            style={{ background: "#ff7f27" }}
                            className="booked-01"
                          >
                            P
                          </a>
                        )}

                        {job.JobStatus === 3 && (
                          <a
                            title="Mark as Accepted"
                            onClick={() =>
                              ChangeJobStatus(
                                job.RelMNVQuoteAndMNVMoverID,
                                4,
                                0,
                              )
                            }
                            className="booked-01"
                            style={{ background: "#00a2e8" }}
                          >
                            C
                          </a>
                        )}

                        {job.LiabilityText !== "" && (
                          <a
                            onClick={() => GetFromFloorText(job.LiabilityText)}
                            className="flex-d"
                            title={job.LiabilityText}
                          >
                            <img
                              src="/images/warning.svg"
                              width="24"
                              height="20"
                              alt="warning"
                            />
                          </a>
                        )}

                        {job.FromFloor !== "" && (
                          <a
                            onClick={() => GetFromFloorText(job.FromFloor)}
                            className="flex-d tooltip-wrapper"
                          >
                            {" "}
                            <img
                              src="/images/flag.svg"
                              width="18"
                              height="20"
                              alt="Flag"
                            />
                            <div
                              className="tooltip2"
                              dangerouslySetInnerHTML={{
                                __html: job.FromFloor,
                              }}
                            ></div>
                          </a>
                        )}

                        {job.ClientInstructions === "" ? (
                          <a
                            className="flex-d"
                            title="View Details"
                            onClick={() =>
                              OpenInfoPopUp_Detail("Summary", job.MNVQuoteID)
                            }
                          >
                            <img
                              src="/images/info-norm.svg"
                              width="20"
                              height="20"
                              alt="Info"
                            />
                          </a>
                        ) : (
                          <a
                            title={job.ClientInstructions}
                            onClick={() =>
                              OpenInfoPopUp_Detail("Summary", job.MNVQuoteID)
                            }
                          >
                            <img
                              src="/images/info-red.svg"
                              width="20"
                              height="20"
                              alt="Info"
                            />
                          </a>
                        )}
                      </div>

                      <div className="flex-da justify-btw c-theme font-12">
                        <span>{formateDate(job.StartTime)}</span>
                        <span>arr {job.RequestedTimeReplaced}</span>
                        <span>for {job.RequiredVanTime}hrs</span>
                      </div>

                      <div className="flex-da justify-btw">
                        <div className="font-12">
                          <span>Postcodes</span>
                        </div>
                        {job.MNVMaterialsPriceTemplateID > 0 && (
                          <a
                            title="Materails Required"
                            className="flex-d"
                            // onClick={() => {
                            //   showMaterailsRequired(job.MNVQuoteID);
                            // }}
                          >
                            <img
                              src="/images/material-req.svg"
                              width="20"
                              height="20"
                              alt="Flag"
                            />
                          </a>
                        )}
                        {job.CongestionFee > 0 && (
                          <a
                            title="Congestion Charges Applied!"
                            className="c-charge"
                          >
                            C
                          </a>
                        )}

                        {job.IsShowLockEmoji === 1 && (
                          <a title="Our Storage" className="flex-d">
                            <img
                              src="/images/lock-g.svg"
                              width="20"
                              height="20"
                              alt="Flag"
                            />
                          </a>
                        )}

                        <span className="c-theme font-13">
                          {job.FromPostalCode} to {job.ToPostalCode}
                        </span>
                      </div>
                    </div>
                  ),
              )}
          </div>
        </div>

        {/* ACCEPTED */}
        <div className="flex-gap10 hide-1150">
          <div className="flex-da justify-btw def-box-head">
            <span className="bold-font text-uppercase font16 c-theme">
              Accepted
            </span>
            <div className="btn-start flex-daj flex-gap10">
              <a
                className="flex-daj btn-primary font-10"
                onClick={() => SendWhatsAppToMover(0)}
              >
                Send All WhatsApp
              </a>
              <a
                className="flex-daj btn-primary font-10"
                onClick={() => SendEmailsToMover(0)}
              >
                Send All Emails
              </a>
            </div>
          </div>
          <div className="flow-boxes flow-boxes2">
            {gridData &&
              gridData.map(
                (job: any, index: any) =>
                  job.JobStatus == 4 && (
                    <div
                      className="shadow-box-sm grid-d flex-gap10"
                      key={index}
                    >
                      <div className="flex-da justify-btw">
                        {/* <span className="job-01">#{job.JobID}</span> */}
                        <div className="grid-d">
                          <span className="job-01">#{job.JobID}</span>
                          {job.ServiceName && job.ServiceName != "" && (
                            <span
                              className="font-12 c-theme"
                              style={{ lineHeight: "12px" }}
                            >
                              {job.ServiceName}
                            </span>
                          )}
                        </div>
                        <a
                          title={GetDriverAndHelpersText(
                            job.MNVQuoteID,
                            false,
                            false,
                            gridDataDB,
                          )}
                          onClick={() =>
                            GetDriverAndHelpersText(
                              job.MNVQuoteID,
                              true,
                              false,
                              gridDataDB,
                            )
                          }
                          className="dh-01"
                        >
                          {job.MNVMoverTypeID === 1 && "D"}
                          {job.MNVMoverTypeID === 2 && "D+1"}
                          {job.MNVMoverTypeID >= 3 &&
                            `D+${job.MNVMoverTypeID - 1}`}
                        </a>

                        {job.VanTypeFirstLetter === "T" && (
                          <span className="van-01 green-box01">
                            {job.VanTypeFirstLetter}
                          </span>
                        )}
                        {job.VanTypeFirstLetter === "L" && (
                          <span className="van-01 blue-box01">
                            {job.VanTypeFirstLetter}
                          </span>
                        )}

                        {/* {IsDriver && ( */}
                        <a
                          title="Mark as Completed"
                          onClick={() =>
                            ChangeJobStatus(
                              job.RelMNVQuoteAndMNVMoverID,
                              5,
                              job.MNVQuoteID,
                              "CompleteJob",
                            )
                          }
                          className="booked-01"
                          style={{ background: "#22b14c" }}
                        >
                          A
                        </a>
                        {/* )} */}

                        {/* {!IsDriver && (
                          <a
                            title="Accepted"
                            className="booked-01"
                            style={{ background: "#22b14c" }}
                          >
                            A
                          </a>
                        )} */}

                        <a
                          onClick={() => SendWhatsAppToMover(job.MNVQuoteID)}
                          className="flex-d"
                          title={"Send WhatsApp"}
                        >
                          <img
                            src="/images/whatsapp.svg"
                            width="24"
                            height="20"
                            alt="env"
                          />
                        </a>

                        <a
                          onClick={() => SendEmailsToMover(job.MNVQuoteID)}
                          className="flex-d"
                          title={"Send Email"}
                        >
                          <img
                            src="/images/envelopen.svg"
                            width="24"
                            height="20"
                            alt="env"
                          />
                        </a>

                        {job.LiabilityText !== "" && (
                          <a
                            onClick={() => GetFromFloorText(job.LiabilityText)}
                            className="flex-d"
                            title={job.LiabilityText}
                          >
                            <img
                              src="/images/warning.svg"
                              width="24"
                              height="20"
                              alt="warning"
                            />
                          </a>
                        )}

                        {job.FromFloor !== "" && (
                          <a
                            onClick={() => GetFromFloorText(job.FromFloor)}
                            className="flex-d tooltip-wrapper"
                          >
                            {" "}
                            <img
                              src="/images/flag.svg"
                              width="18"
                              height="20"
                              alt="Flag"
                            />
                            <div
                              className="tooltip2"
                              dangerouslySetInnerHTML={{
                                __html: job.FromFloor,
                              }}
                            ></div>
                          </a>
                        )}

                        <a
                          className="flex-d"
                          title="Messages"
                          onClick={() =>
                            OpenMessagePopUp_Detail("", job.MNVQuoteID)
                          }
                        >
                          <img
                            src="/images/comment-t.svg"
                            width="20"
                            height="20"
                            alt="Info"
                          />
                        </a>

                        {job.ClientInstructions === "" ? (
                          <a
                            className="flex-d"
                            title="View Details"
                            onClick={() =>
                              OpenInfoPopUp_Detail("Summary", job.MNVQuoteID)
                            }
                          >
                            <img
                              src="/images/info-norm.svg"
                              width="20"
                              height="20"
                              alt="Info"
                            />
                          </a>
                        ) : (
                          <a
                            title={job.ClientInstructions}
                            onClick={() =>
                              OpenInfoPopUp_Detail("Summary", job.MNVQuoteID)
                            }
                          >
                            <img
                              src="/images/info-red.svg"
                              width="20"
                              height="20"
                              alt="Info"
                            />
                          </a>
                        )}
                      </div>

                      <div className="flex-da justify-btw c-theme font-12">
                        <span>{formateDate(job.StartTime)}</span>
                        <span>arr {job.RequestedTimeReplaced}</span>
                        <span>for {job.RequiredVanTime}hrs</span>
                      </div>

                      <div className="flex-da justify-btw">
                        <div className="font-12">
                          <span>Postcodes</span>
                        </div>
                        {job.MNVMaterialsPriceTemplateID > 0 && (
                          <a
                            title="Materails Required"
                            className="flex-d"
                            onClick={() => {
                              showMaterailsRequired(job.MNVQuoteID);
                            }}
                          >
                            <img
                              src="/images/material-req.svg"
                              width="20"
                              height="20"
                              alt="Flag"
                            />
                          </a>
                        )}
                        {job.CongestionFee > 0 && (
                          <a
                            title="Congestion Charges Applied!"
                            className="c-charge"
                          >
                            C
                          </a>
                        )}

                        {job.IsShowLockEmoji === 1 && (
                          <a title="Our Storage" className="flex-d">
                            <img
                              src="/images/lock-g.svg"
                              width="20"
                              height="20"
                              alt="Flag"
                            />
                          </a>
                        )}

                        <span className="c-theme font-13">
                          {job.FromPostalCode} to {job.ToPostalCode}
                        </span>
                      </div>
                    </div>
                  ),
              )}
          </div>
        </div>

        {/* COMPLETED */}
        <div className="flex-gap10">
          <div className="flex-da justify-btw def-box-head">
            <span className="bold-font text-uppercase font16 c-theme">
              Completed
            </span>
          </div>
          <div className="flow-boxes flow-boxes2">
            {gridData &&
              gridData.map(
                (job: any, index: any) =>
                  job.JobStatus == 5 && (
                    <div
                      className="shadow-box-sm grid-d flex-gap10"
                      key={index}
                    >
                      <div className="flex-da justify-btw">
                        {/* <span className="job-01">#{job.JobID}</span> */}
                        <div className="grid-d">
                          <span className="job-01">#{job.JobID}</span>
                          {job.ServiceName && job.ServiceName != "" && (
                            <span
                              className="font-12 c-theme"
                              style={{ lineHeight: "12px" }}
                            >
                              {job.ServiceName}
                            </span>
                          )}
                        </div>
                        <a
                          title={GetDriverAndHelpersText(
                            job.MNVQuoteID,
                            false,
                            false,
                            gridDataDB,
                          )}
                          onClick={() =>
                            GetDriverAndHelpersText(
                              job.MNVQuoteID,
                              true,
                              false,
                              gridDataDB,
                            )
                          }
                          className="dh-01"
                        >
                          {job.MNVMoverTypeID === 1 && "D"}
                          {job.MNVMoverTypeID === 2 && "D+1"}
                          {job.MNVMoverTypeID >= 3 &&
                            `D+${job.MNVMoverTypeID - 1}`}
                        </a>

                        {job.VanTypeFirstLetter === "T" && (
                          <span className="van-01 green-box01">
                            {job.VanTypeFirstLetter}
                          </span>
                        )}
                        {job.VanTypeFirstLetter === "L" && (
                          <span className="van-01 blue-box01">
                            {job.VanTypeFirstLetter}
                          </span>
                        )}

                        <a
                          title="Completed"
                          style={{ background: "#a349a4" }}
                          className="booked-01"
                        >
                          C
                        </a>

                        {job.LiabilityText !== "" && (
                          <a
                            onClick={() => GetFromFloorText(job.LiabilityText)}
                            className="flex-d"
                            title={job.LiabilityText}
                          >
                            <img
                              src="/images/warning.svg"
                              width="24"
                              height="20"
                              alt="warning"
                            />
                          </a>
                        )}

                        {job.FromFloor !== "" && (
                          <a
                            onClick={() => GetFromFloorText(job.FromFloor)}
                            className="flex-d tooltip-wrapper"
                          >
                            {" "}
                            <img
                              src="/images/flag.svg"
                              width="18"
                              height="20"
                              alt="Flag"
                            />
                            <div
                              className="tooltip2"
                              dangerouslySetInnerHTML={{
                                __html: job.FromFloor,
                              }}
                            ></div>
                          </a>
                        )}

                        <a
                          className="flex-d"
                          title="Messages"
                          onClick={() =>
                            OpenMessagePopUp_Detail("", job.MNVQuoteID)
                          }
                        >
                          <img
                            src="/images/comment-t.svg"
                            width="20"
                            height="20"
                            alt="Info"
                          />
                        </a>

                        {job.ClientInstructions === "" ? (
                          <a
                            className="flex-d"
                            title="View Details"
                            onClick={() =>
                              OpenInfoPopUp_Detail("Summary", job.MNVQuoteID)
                            }
                          >
                            <img
                              src="/images/info-norm.svg"
                              width="20"
                              height="20"
                              alt="Info"
                            />
                          </a>
                        ) : (
                          <a
                            title={job.ClientInstructions}
                            onClick={() =>
                              OpenInfoPopUp_Detail("Summary", job.MNVQuoteID)
                            }
                          >
                            <img
                              src="/images/info-red.svg"
                              width="20"
                              height="20"
                              alt="Info"
                            />
                          </a>
                        )}
                      </div>

                      <div className="flex-da justify-btw c-theme font-12">
                        <span>{formateDate(job.StartTime)}</span>
                        <span>arr {job.RequestedTimeReplaced}</span>
                        <span>for {job.RequiredVanTime}hrs</span>
                      </div>

                      <div className="flex-da justify-btw">
                        <div className="font-12">
                          <span>Postcodes</span>
                        </div>
                        {job.MNVMaterialsPriceTemplateID > 0 && (
                          <a
                            title="Materails Required"
                            className="flex-d"
                            onClick={() => {
                              showMaterailsRequired(job.MNVQuoteID);
                            }}
                          >
                            <img
                              src="/images/material-req.svg"
                              width="20"
                              height="20"
                              alt="Flag"
                            />
                          </a>
                        )}
                        {job.CongestionFee > 0 && (
                          <a
                            title="Congestion Charges Applied!"
                            className="c-charge"
                          >
                            C
                          </a>
                        )}

                        {job.IsShowLockEmoji === 1 && (
                          <a title="Our Storage" className="flex-d">
                            <img
                              src="/images/lock-g.svg"
                              width="20"
                              height="20"
                              alt="Flag"
                            />
                          </a>
                        )}

                        <span className="c-theme font-13">
                          {job.FromPostalCode} to {job.ToPostalCode}
                        </span>
                      </div>
                    </div>
                  ),
              )}
          </div>
        </div>
      </div>

      {showQuoteModal && (
        <div className="popup-help popup-help-index">
          <div className="help-popup-display">
            <div className="help-inner lg-popup">
              <div className="help-head flex-da justify-btw">
                <h3 className="bold-font flex-d m-all0">Summary</h3>
                <a
                  className="close-help"
                  onClick={() => setShowQuoteModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>

              <QuoteInfo QuoteID={quoteID} />
              <div className="flex-daj gap-10 mt-20">
                <div className="flex-daj btn-start">
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => setShowQuoteModal(false)}
                  >
                    Cancel
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showMaterialsModal && (
        <div className="popup-help popup-help-index">
          <div className="help-popup-display">
            <div className="help-inner sm-popup">
              <div className="help-head flex-da justify-btw">
                <h3 className="bold-font flex-d m-all0">Materials</h3>
                <a
                  className="close-help"
                  onClick={() => setShowMaterialsModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="grid-d flex-gap10 mt-20">
                <span className=" font-16 bold-font">Number Of Boxes Used</span>
                <div className="field-input">
                  <input
                    className="input-field w-100"
                    placeholder="Number Of Boxes Used"
                    value={numberOfBoxes}
                    onChange={(e: any) => setNumberOfBoxes(e.target.value)}
                  />
                </div>
              </div>
              <div className="grid-d flex-gap10 mt-20">
                <span className="font-16 bold-font">Notes</span>
                <div className="field-input">
                  <input
                    className="input-field w-100"
                    placeholder="Notes"
                    value={materialsNotes}
                    onChange={(e) => setMaterialsNotes(e.target.value)}
                  />
                </div>
              </div>

              <div className="flex-daj btn-start gap-10 mt-20">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => saveMaterialsNotes()}
                >
                  Save
                </a>

                <a
                  className="btn-primary flex-daj"
                  onClick={() => setShowMaterialsModal(false)}
                >
                  Close
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      {showCompleteModal && (
        <div className="popup-help popup-help-index">
          <div className="help-popup-display">
            <div className="help-inner lg-popup">
              <div className="help-head flex-da justify-btw">
                <h3 className="bold-font flex-d m-all0">
                  Mark job as completed
                </h3>
                <a
                  className="close-help"
                  onClick={() => setShowCompleteModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="grid-d mt--15">
                <CompleteJob
                  QuoteID={driverFeedback.MNVQuoteID}
                  RelMNVQuoteAndMNVMoverID={
                    driverFeedback.RelMNVQuoteAndMNVMoverID
                  }
                  ClosePopupAndAutoSendSms={ClosePopupAndAutoSendSms}
                />
              </div>

              {/* <div className="flex-daj gap-10 mt-20">
                <div className="flex-daj btn-start">
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => setShowCompleteModal(false)}
                  >
                    Cancel
                  </a>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      )}

      {showMessageModal && (
        <div className="popup-help popup-help-index">
          <div className="help-popup-display">
            <div className="help-inner lg-popup">
              <div className="help-head flex-da justify-btw">
                <h3 className="bold-font flex-d m-all0">Messages</h3>
                <a
                  className="close-help"
                  onClick={() => setShowMessageModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              {quoteID > 0 && (
                <div>
                  <Conversation
                    OtherEntityID={quoteID}
                    MessageTypeID={4}
                    AutoSaveMessage={AutoSaveMessage}
                    ShowMoveLeader={2}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default DriversDashboard;
